import { Container, Row, Col, Card } from "react-bootstrap";

function About() {
  return (
    <div className="page-hero">
      <Container>
        <Row className="g-4 align-items-start">
          <Col lg={7}>
            <h1 className="hero-title">
              Building technology that helps African businesses grow
            </h1>
            <p className="hero-copy mt-3">
              CodeCamp was founded to help businesses across Africa use
              technology to increase efficiency, improve customer experience,
              and unlock new opportunities for growth.
            </p>
            <p className="hero-copy">
              We combine software engineering, design, and modern AI tools to
              build practical solutions that solve real business challenges.
            </p>
          </Col>
          <Col lg={5}>
            <Card className="page-card">
              <h5 className="fw-bold">Our mission</h5>
              <p className="text-muted mb-3">
                To empower African businesses with innovative digital solutions
                that drive growth and improve productivity.
              </p>
              <h5 className="fw-bold">Our values</h5>
              <ul className="text-muted mb-0">
                <li>Build with purpose</li>
                <li>Put customers first</li>
                <li>Deliver quality</li>
                <li>Think long term</li>
              </ul>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;
